import {useEffect, useState, useMemo} from 'react';
// import PropTypes from 'prop-types';
// import { JsonView } from 'react-json-view-lite';
import {NewsLetterService} from '../../services/newsletter.service';
import { useCompanyId } from '../../services/CompanyidProvider';
import { MaterialReactTable } from 'material-react-table';
import {  FluxButton,FluxCircularProgress  } from '@meltwater/flux-web-components-react';
import csvDownload from 'json-to-csv-export'


const Newsletters = (props) => {
    const [data, setData] = useState(null);
  const { companyId } = useCompanyId();
  const columns = useMemo(
    () => [
      {
        header: 'Name',
    
        accessorKey: 'name', //simple accessorKey pointing to flat data
      },
      {
        header: 'id',
       
        accessorKey: 'id', //simple accessorKey pointing to flat data
     
      },
      {
        header: 'distributionCount',
       
        accessorKey: 'distributionCount', //simple accessorKey pointing to flat data
     
      },
      
     
      {
        header: 'Type',
        accessorFn: (row) => `${row.type}`,
    
        // accessorKey: 'searchQuery.filter.id', //simple accessorKey pointing to flat data
      }
      
    ],
    [],
  );
  useEffect(() => {
    async function fetchData() {
      let myres;
        try {
          console.log(`getdistributions`);
          myres = await NewsLetterService.getdistributions(companyId)
          setData(myres.data);
        } catch (error) {
          console.log(`FAIL`,error);
          // setCompanyId("");
        }
     
    }
    if (props.load && !data)
    {
    fetchData();
    }
  },[companyId,props.load,data]);
  const handleExportData = () => {
    
    // const errortab= props.tabledata.filter()
   const exportdata = data.map((oneitem)=>{
  
      
     
    
      return {
        name: oneitem.name,
        id: oneitem.id,
        visible: oneitem.visible,
        country: (oneitem.filters.country).toString(),

        
      }

   })
    const exdata = {
      data: exportdata,
      delimiter: ',',
      filename: `Distributions for ${companyId}`,
      
    }
   
    
    csvDownload(exdata)
    
  };
  const handleExportRows = (rows) => {
    console.log("ROWS ",rows)
    // const errortab= props.tabledata.filter()
   const exportdata = rows.map((oneitem)=>{
    //console.log("ONE ITEM ",oneitem.searchQuery.allKeywords)
      
     
      let response= {
        name: oneitem.original.name,
        id: oneitem.original.id,
        // visible: oneitem.original.visible,
        // booleans: (oneitem.original.filters.booleans).toString(),
        // country: (oneitem.original.filters.country).toString(),
        // sentiment: (oneitem.original.filters.sentiment).toString(),

        // language: (oneitem.original.filters.language).toString(),
        // sourceType: (oneitem.original.filters.sourceType).toString(),
        // subKeyword: (oneitem.original.filters.subKeyword).toString(),
        // newsSource: (oneitem.original.filters.newsSource).toString(),
        // rssSource: (oneitem.original.filters.rssSource).toString(),
        // geoname: (oneitem.original.filters.geoname).toString(),
        // authorList: (oneitem.original.filters.authorList).toString(),
        // customCategory: (oneitem.original.filters.customCategory).toString(),
        // newsReach: (oneitem.original.filters.newsReach).toString(),
        // newsPremiumTypes: (oneitem.original.filters.newsPremiumTypes).toString(),
        // newsOutletTypes: (oneitem.original.filters.newsOutletTypes).toString(),
        // broadcastSubtypes: (oneitem.original.filters.broadcastSubtypes).toString(),
        // newsMediaFormats: (oneitem.original.filters.newsMediaFormats).toString(),


       
      }
      return response;

   })
    const data = {
      data: exportdata,
      delimiter: ',',
      filename: `Filters for ${companyId}`,
      
    }
   
    
    csvDownload(data)
    
  };
  const divStyle = {
    backgroundColor: '#ffffff',
   //border: '1px solid #000', // You can customize the border style here
    padding: '10px', // Optional: You can also add padding
    borderRadius: '10px',
    width:'100px'
    
  };
return(  <div className={divStyle}>
    
    { !data && <><FluxCircularProgress indeterminate size="400">Loading...</FluxCircularProgress></>}
    { data &&  
  
    <MaterialReactTable
     sx={{ overflowX: 'scroll' }}
        columns={columns}
        data={data.data}
        //enable some features
        enableRowSelection 
        enableSelectAll
        enableStickyHeader
        layoutMode='grid'
        
        enableGlobalFilter={false} //turn off a feature
        initialState={{ density: 'compact',columnVisibility: {Boolean:false, Language: false ,AnySearches: false,AllSearches: false,NotSearches: false,Country:false, Query: false ,FilterName:false, FilterID:false}, pagination: { pageSize: 100} }}
        renderTopToolbarCustomActions={({ table }) => (
         <div key={table.row}>
           
              <FluxButton
                tint="primary"
                type="filled"
                //export all data that is currently in the table (ignore pagination, sorting, filtering, etc.)
                onClick={handleExportData}
                
              >
                Export All Data
              </FluxButton>
              <FluxButton
                  tint="accent"
                  type="filled"
                //export all data that is currently in the table (ignore pagination, sorting, filtering, etc.)
                onClick={() => handleExportRows(table.getSelectedRowModel().rows)}
                disabled={
                  !table.getIsSomeRowsSelected() && !table.getIsAllRowsSelected()
                }
              >
                Export Selected
              </FluxButton>
             
            </div>
        )}


      />
       
    
    }
  </div>

  
)};


export default Newsletters;
